module.exports = __webpack_public_path__ + "img/55428723442_c0589dd564_o.6822e450.jpg";